import {
    SeatingChartController, SeatingChartWrapperConfig
} from "../../shared_components/seating-chart-2/SeatingChartController";

export class TicketSelectionMapController extends SeatingChartController {

    //
    // constructor(svgElement: HTMLImageElement,
    //             containerElement: HTMLDivElement,
    //             config: SeatingChartWrapperConfig = new SeatingChartWrapperConfig()) {
    //     super(svgElement, containerElement, config);
    //
    //     //let btn = document.getElementById("coolbutton")! as HTMLInputElement;
    //     //btn.addEventListener("click", (e: Event) => this.Test());
    //     //btn.disabled = true;
    // }

    public Test() {
        //seatingChartWrapper.goToBoard();
    }

}


// let seatingChartWrapper = SeatingChartController.attachByIds(TicketSelectionMapController, 'seatplan_svg', 'seatplan_div');
// (<any>window).vm = {};
// (<any>window).vm.map = seatingChartWrapper;


